module.exports = __webpack_public_path__ + "img/organization.a07a104e.svg";